<template>
  <v-container
    fill-height
  >
    <v-card
      v-if="permitted"
      outlined
      class="mx-auto"
      style="width: 40rem;"
    >
      <v-card-text>
        <p>
          定期課金に使用されているクレジットカードが使用できませんでした。<br>
          お支払い日にお引き落としができませんでした。<br>
          引き落とし可能なクレジットカードを再度登録ください。
        </p>

        <v-row v-if="has_card">
          <v-col cols="12">
            <h4>ご利用中のカード</h4>
            <v-row>
              <v-col
                cols="12"
                sm="6"
              >
                <div class="overline">
                  ブランド
                </div>
                <h4>{{ card.brand }}</h4>
                <v-divider />
              </v-col>
              <v-col
                cols="12"
                sm="6"
              >
                <div class="overline">
                  有効期限
                </div>
                <h4>{{ card.exp }}</h4>
                <v-divider />
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <div class="overline">
                  カード番号
                </div>
                <h4>{{ card.num }}</h4>
                <v-divider />
              </v-col>

              <v-col
                cols="12"
                sm="6"
              >
                <div class="overline">
                  名義人
                </div>
                <h4>{{ card.name }}</h4>
                <v-divider />
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <v-row>
          <v-col
            cols="12"
            align="end"
          >
            <payjp-checkout
              v-if="permitted"
              :key="reloadKey"
              :api-key="public_key"
              text="カードを差し替え"
              :tenant="agency_id"
              :default-email="customerEmail"
              :partial="true"
              submit-text="カードを差し替え"
              name-placeholder="TARO RENTAL"
              :on-created-handler="onTokenCreated"
            />
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <template
      v-else
    >
      <v-row>
        <v-col
          cols="12"
          md="6"
          offset-md="3"
        >
          <v-card flat>
            <v-card-text>
              <div class="text-center">
                <h1>404 Not Found</h1>
                <h4>ご指定のページが見つかりません。</h4>
                <br />
                <p>
                  お客様がお探しのページが見つかりませんでした。<br/>
                  削除されたか、入力したURLが間違っている可能性があります。
                </p>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
  </v-container>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import alertMessage from '../../../components/AlertMessage'
import PayjpCheckout from '../../../plugins/PayjpCheckout';

export default {
  name: 'CardSwitchShow',
  components: {
    alertMessage,
    PayjpCheckout,
  },
  mixins: [],
  data () {
    return {
      public_key: process.env.PAY_JP_PUBLIC_KEY,
      token: null,
      permitted: false,
      has_card: false,
      agency_id: null,
      reloadKey: 0,
      customerEmail: null,
      card: {
        brand: null,
        exp: null,
        num: null,
        name: null,
      }
    }
  },
  computed: {
    ...mapState('alertMessage', {
      isShow: 'isShow',
      color: 'color',
      message: 'message'
    }),
  },
  created () {
    this.signOut()
    this.token = this.$route.params.token
    this.fetchSetting().then((content) => {
      this.agency_id = content.agency_id;
      this.fetchCardInfo();
    })
  },

  methods: {
    ...mapActions('frontCardSwitch', {
      fetchCard: 'fetch',
      updateCard: 'update'
    }),
    ...mapActions('frontAuth', {
      signOut: 'signOutFrontend',
    }),
    ...mapActions("frontSystemSetting", {
      fetchSetting: "find",
    }),
    fetchCardInfo () {
      this.fetchCard({token: this.token}).then((content) => {
        this.customerEmail = content.email;
        this.permitted = true
        this.has_card = content.has_card
        this.card = content.card
      })
    },
    onTokenCreated (response) {
      // カードのToken化に成功
      const params = {
        card_token: response.id,
      }
      this.updateCard({ token: this.token, params }).then(() => {
        this.$router.push({name: 'CardSwitchCompleted'})
      })
    },
  },


}
</script>

<style scoped>

</style>